<template>
  <div class="top">
    <div class="left_menu">
      <div class="menu_title">浙江机电杂志</div>
      <el-scrollbar height="750">
        <div class="left_item" v-for="(item, index) in title_list" :key="'leitem' + index"
          @mouseenter="() => (hoverWhich = item.id)" @mouseleave="() => (hoverWhich = null)" @click="changeList(item)"
          :class="{
          choose_is: hoverWhich === item.id || pushValue.ctypeId === item.id,
        }">
          <img :src="hoverWhich === item.id || pushValue.ctypeId === item.id
            ? img2
            : img1
          " alt="" />
          <div class="article_name">{{ item.title }}</div>
        </div>
      </el-scrollbar>
    </div>
    <div class="right_article">
      <el-scrollbar height="750">
        <div v-for="(item, index) in article_list" :key="'article_list' + index" class="article_list"
          @click="downloadLetter(item)">
          <div class="dot"></div>
          {{ item.title }}
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>
<script setup>
import { nextTick, reactive, ref, watch } from "vue";
import api from "@/api/api";
let img1 = require("@/assets/text/jiantou1.png");
let img2 = require("@/assets/text/jiantou2.png");
let title_list = ref([]);
let article_list = ref([]);
let hoverWhich = ref(null);
let selectedItem = ref({});
let pushValue = reactive({
  resourceId: 110,
  ctypeId: "",
});
const getList = async () => {
  let res = await api.getPublicationClassification();
  if (res.code === "0") {
    title_list.value = res.res.data;
    pushValue.ctypeId = title_list.value[0].id;
    nextTick(() => {
      getFallList();
    });
  }
};
getList();
const getFallList = async () => {
  let res = await api.getZtzlList(pushValue);
  if (res.code === "0") {
    article_list.value = res.res.data;
  }
};
const changeList = (item) => {
  selectedItem.value = item;
  nextTick(() => {
    getFallList();
  });
};
const downloadLetter = (data) => {
  let url = data.thumbUrl;
  let fileName = data.thumb;

  // fetch(url).then((res) => {
  //   res.blob().then((blob) => {
  //     const blobUrl = window.URL.createObjectURL(blob);

  //     const filename = fileName;

  //     const a = document.createElement("a");

  //     a.href = blobUrl;

  //     a.download = filename;

  //     a.click();

  //     window.URL.revokeObjectURL(blobUrl);
  //   });
  // });
  window.open(url, "_blank");
};
watch(
  () => selectedItem.value,
  (newValue) => {
    if (newValue) {
      pushValue.ctypeId = newValue.id;
    }
  },
  { deep: true, immediate: true }
);
</script>
<style lang="less" scoped>
.dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #606060;
  margin-right: 14px;
}

.top {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: 32px 160px;
  padding-bottom: 160px;

  .left_menu {
    width: 300px;
    height: 800px;
    background: #efefee;
    margin-right: 30px;

    .menu_title {
      background: #4274cc;
      color: #ffffff !important;
      padding-left: 38px;
      height: 50px;
      line-height: 50px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      text-align: justify;
      font-style: normal;
    }

    .left_item {
      height: 50px;
      line-height: 50px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      text-align: justify;
      font-style: normal;
      color: #333333;
      display: flex;
      align-items: center;
      padding-left: 39px;

      img {
        width: 7px;
        height: 10px;
        margin-right: 7px;
      }

      .article_name {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        // color: #4174cb;
        text-align: justify;
        font-style: normal;
        cursor: default;
      }
    }

    .choose_is {
      background: #b6ccec !important;
      color: #4174cb !important;
    }
  }

  .right_article {
    flex: 1;
    height: 613px;
    padding: 15px 30px 15px 37px;
    box-sizing: border-box;
    background: #faf9f9;
    border: 1px solid #dedede;

    .article_list {
      height: 50px;
      border-bottom: 1px dashed #e1e1e1;
      display: flex;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      font-style: normal;
      cursor: pointer;
    }

    .article_list:hover {
      background: #b6ccec !important;
      color: #4174cb !important;
    }
  }
}
</style>